import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUp } from "react-icons/fi";
import { navLinks } from "../nav/Nav";
import { profile } from "../../data/resume";
import "./footer.css";

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer__top">
        <nav className="footer__links" aria-label="Footer">
          {navLinks.map((link) => (
            <Link key={link.id} to={`/#${link.id}`}>
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="footer__social">
          <a href={profile.linkedin} target="_blank" rel="noreferrer">
            LinkedIn
          </a>
          <a href={profile.github} target="_blank" rel="noreferrer">
            GitHub
          </a>
          <button
            type="button"
            className="footer__top-btn"
            aria-label="Back to top"
            onClick={() => window.scrollTo({ top: 0 })}
          >
            <FiArrowUp />
          </button>
        </div>
      </div>

      {/* SVG text stretched to the container width, so the wordmark always fits edge to edge. */}
      <svg className="footer__wordmark" viewBox="0 0 1000 122" aria-hidden="true">
        <defs>
          <linearGradient id="wordmark-fade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="currentColor" stopOpacity="0.9" />
            <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
        </defs>
        <text x="0" y="100" textLength="1000" lengthAdjust="spacing" fill="url(#wordmark-fade)">
          Yaseen Al-Midani
        </text>
      </svg>

      <div className="footer__bottom">
        <small>
          © {new Date().getFullYear()} {profile.name}
        </small>
        <small>Designed & engineered in {profile.city}</small>
      </div>
    </div>
  </footer>
);

export default Footer;
